import ReactDOM from 'react-dom'
import { AppContainer } from 'react-hot-loader'
import 'shared/css/global-fonts.css'
import 'shared/trackjs'
import Video404 from './components/404'
import PlaylistEmbed from './components/playlist'
import Video from './components/video'

let clips = new URL(location.href).searchParams.get('clips')
clips = clips ? clips.split(',') : []
global.Giphy = global.Giphy || {}
global.Giphy.renderVideoEmbed = (el, data) => {
    ReactDOM.render(
        <AppContainer
            warnings={false}
            errorReporter={({ error }) => {
                throw error
            }}
        >
            {data.is404 ? <Video404 /> : clips.length === 0 ? <Video {...data} /> : <PlaylistEmbed {...data} />}
        </AppContainer>,
        el
    )
}
